export default __webpack_public_path__ + "static/media/projTrack2Full.e0fd9465.png";